import React, { useEffect, useState, useRef } from "react";
import ReplyArea from "./ReplyArea";
import TimeSign from './TimeSign';
import Message from './Message';
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useGetMessagesQuery } from '../../../../features/user/userApiSlice';
import { useSelector } from "react-redux";
import { selectCurrentUser, selectCurrentSocket, clearUnreadMessagesByUser } from './../../../../features/auth/authSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { useMarkConversationReadMutation } from '../../../../features/user/userApiSlice';

const Chat = ({}) => {
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState(false);

    const { t } = useTranslation();
    const user = useSelector(selectCurrentUser);
    const socket = useSelector(selectCurrentSocket);
    const location = useLocation();
    const dispatch = useDispatch();
    const { firstName, lastName } = useParams();
    const [searchParams] = useSearchParams();
    const { data, isLoading } = useGetMessagesQuery(location?.state?.userId ? location.state.userId : searchParams.get('targetUser'));
    const [arrivalMessage, setArrivalMessage] = useState(null);
    const [markConversationRead] = useMarkConversationReadMutation();
    const targetUserId = Number(location?.state?.userId ? location.state.userId : searchParams.get('targetUser'));
    const scrollRef = useRef();
    //const socket = useRef();

    useEffect(() => {
        if (targetUserId) {
            dispatch(clearUnreadMessagesByUser({ targetUser: targetUserId }));
            markConversationRead(targetUserId);
        }
    }, [targetUserId]);

    useEffect(() => {
        //socket.current = io(`ws://localhost:5000`);
        //socket.current = io(`http://localhost:5000`);
        if (socket) {
            const onMessage = data => {
                if (Number(data.senderFK) !== targetUserId) return;
                setArrivalMessage({
                    id: data.id,
                    senderFK: Number(data.senderFK),
                    receiverFK: data.receiverFK,
                    message: data.message,
                    avatar: data.avatar,
                    create_time: data.create_time || new Date().toISOString()
                });
                dispatch(clearUnreadMessagesByUser({ targetUser: targetUserId }));
                markConversationRead(targetUserId);
            };
            socket.on('getMessage', onMessage);

            const onTyping = typing => {
                setIsTyping(typing);
            };
            socket.on('displayTyping', onTyping);
            return () => {
                socket.off('getMessage', onMessage);
                socket.off('displayTyping', onTyping);
            };
            
        } else {
            console.log('socket is not available');
        }
        
    }, [socket]);

    useEffect(() => {
        if (arrivalMessage) {
            setMessages(prev => [...prev, arrivalMessage]);            
        }
    }, [arrivalMessage]);

    // useEffect(() => {
    //     if (socket.current) {
    //         if (user) {
    //             socket.current.emit('sendUser', user.id);
    //         }

    //         socket.current.on('getUsers', users => {
    //             console.log('from server get users');
    //             console.log(users);
    //         });
    //     }        
    // }, [user]);

    useEffect(() => {
        if (!isLoading && user) {
            setMessages([]);               
            setMessages(data);        
        }
    }, [isLoading, data]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages, isTyping]);


    return <div style={{ maxHeight: '730px' }} className="message-content">
        {searchParams.get('lastName') != null &&<div className="messages-headline">
             <h4>{`${firstName ? firstName : searchParams.get('firstName')} ${lastName ? lastName : searchParams.get('lastName')}`}</h4>
            {false && <a href="#" className="message-action"><i className="icon-feather-trash-2"></i> {t('DeleteConversation')}</a>}
        </div>}

        <div ref={scrollRef} className="message-content-inner">

            {(!isLoading && user) &&
                messages?.map((m, i) => 
                    <Message key={i} {...m}
                    isMe={(user?.id == m?.senderFK)} />)
            }

            {isTyping ?
             <Message avatar={location.state.receiverAvatar} isTyping={true} />
            : null}
        </div>

        {searchParams.get('lastName') != null &&
        <ReplyArea 
        avatar={user?.avatar}
        socket={socket}
        setMessages={setMessages} 
        messages={messages} 
        senderId={user?.id} 
        senderFullName={`${user?.firstName} ${user?.lastName}`}
        receiverId={targetUserId} />}
    </div>;
}

export default Chat;
